var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/UuidService/UuidService", "hypo_elements/Typescripts/GoogleAnalyticsTrackingService/GoogleAnalyticsTrackingService", "hypo_elements/Typescripts/SendEvent/CheckSendEvent", "jquery"], function (require, exports, UuidService, GoogleAnalyticsTrackingService, CheckSendEvent) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    UuidService = __importStar(UuidService);
    GoogleAnalyticsTrackingService = __importStar(GoogleAnalyticsTrackingService);
    CheckSendEvent = __importStar(CheckSendEvent);
    $(function () {
        var uuidPromise = UuidService.getUuid();
        var $beraterKontaktformular = $(".beraterKontaktformular");
        var $beraterKontaktformularForm = $beraterKontaktformular.find(".beraterKontaktformular_form");
        var $confirmationDialog = $beraterKontaktformular.find(".beraterKontaktformular_confirmationDialog");
        var $errorDialog = $beraterKontaktformular.find(".beraterKontaktformular_errorDialog");
        var url = "/rest-api/anfragen/kontakt";
        var formNameForTracking = "berater-kontaktformular";
        if (CheckSendEvent.sentEvent('beraterKontaktformular')) {
            uuidPromise.done(function (uuid) {
                GoogleAnalyticsTrackingService.submitCheckoutTracking(uuid, formNameForTracking);
            });
        }
        $beraterKontaktformularForm.on("submit", function (event) {
            window.dispatchEvent(new CustomEvent('hypoport.drklein.gaTrackingVirtualPage', {
                detail: {
                    event: 'VirtualPageview',
                    virtualPageURL: window.location.pathname.replace('.html', '/kontaktformular.html'),
                    virtualPageTitle: 'Step 1 Beraterformular – Kontaktformular',
                }
            }));
            window.dispatchEvent(new CustomEvent('hypoport.drklein.gaTracking', {
                detail: {
                    event: 'Lead',
                    gaEventCategory: 'Lead',
                    gaEventAction: 'Step 1 | Beraterformular',
                    gaEventLabel: ''
                }
            }));
            uuidPromise
                .done(function (uuid) {
                submitForm($beraterKontaktformularForm, uuid);
            })
                .fail(function () {
                handleFailedSubmit();
                uuidPromise = UuidService.getUuid();
            })
                .always(function () {
                event.preventDefault();
            });
            event.preventDefault();
        });
        function submitForm($form, uuid) {
            $form.find("input[name=uuid]").val(uuid);
            $.post(url, $form.serialize())
                .done(handleSuccessfulSubmit)
                .fail(handleFailedSubmit);
        }
        function handleSuccessfulSubmit() {
            uuidPromise.done(function (uuid) {
                GoogleAnalyticsTrackingService.submitPurchaseTracking(uuid, formNameForTracking);
            });
            $errorDialog.hide();
            $beraterKontaktformularForm.hide();
            $confirmationDialog.show();
            $beraterKontaktformularForm.trigger("reset");
            window.dispatchEvent(new CustomEvent('hypoport.drklein.gaTrackingVirtualPage', {
                detail: {
                    event: 'VirtualPageview',
                    virtualPageURL: window.location.pathname.replace('.html', '/kontaktformular/danke.html'),
                    virtualPageTitle: 'Step 2 Beraterformular – Kontaktformular versendet',
                }
            }));
            window.dispatchEvent(new CustomEvent('hypoport.drklein.gaTracking', {
                detail: {
                    event: 'Lead',
                    gaEventCategory: 'Lead',
                    gaEventAction: 'Step 2 | Beraterformular erfolgreich versendet',
                    gaEventLabel: ''
                }
            }));
        }
        function handleFailedSubmit() {
            $confirmationDialog.hide();
            $errorDialog.show();
        }
    });
});
